import { Cohort } from '~/shared/constants/commonConstants'
import { BIOLOGY_THEME, COMMUNICATION_THEME } from '~/shared/styles/theme'

export const THEME_BASED_COHORT = {
  [Cohort.BIOLOGY]: BIOLOGY_THEME,
  [Cohort.ANATOMY]: BIOLOGY_THEME,
  [Cohort.ANATOMY_ALT]: BIOLOGY_THEME,
  [Cohort.COMMUNICATION]: COMMUNICATION_THEME,
  [Cohort.ART]: BIOLOGY_THEME,
  [Cohort.GENERAL]: BIOLOGY_THEME,
} as const
